export default __webpack_public_path__ + "static/media/052-kosovo.cf3d0291.svg";